export default class DocNavigationController {
	constructor() {
		this.doc = document.querySelector(".js-doc");
		if (this.doc === null || undefined) return;
		this.navs = Array.from(document.querySelectorAll(".js-doc-nav"));
		this.doc.chapters = Array.from(
			this.doc.querySelectorAll(".js-doc-chapter")
		);
		this.scrollY = 0;
		this.mobileNavIsOpen = false;

		this.onEventTriggered = ::this.onEventTriggered;
		this.header = document.querySelector("header");

		this.initEvents();
	}

	initEvents() {
		window.addEventListener("scroll", this.onEventTriggered);
		window.addEventListener("resize", this.onEventTriggered);
	}

	static getMain() {
		return document.querySelector("main");
	}

	static getMainSectionsContent() {
		return Array.from(
			document
				.querySelector("main")
				.querySelectorAll(".js-main-section-content")
		);
	}

	static getTopOffset(element) {
		return element.getBoundingClientRect().top;
	}

	static getMainheadlines() {
		return Array.from(document.querySelectorAll(".js-main-content-headline"));
	}

	static getOffset() {
		const padding = window.getComputedStyle(
			DocNavigationController.getMainSectionsContent()[0]
		)["padding-top"];
		return (
			parseInt(
				document.querySelector("header").getBoundingClientRect().height
			) + parseInt(padding.substring(0, padding.length - 2))
		);
	}

	getHeight(element) {
		return element.getBoundingClientRect().height;
	}

	getPointOfInterest() {
		return window.outerHeight / 2 - DocNavigationController.getOffset();
	}

	onToggleClicked(e) {
		if (this.mobileNavIsOpen) {
			this.docNavListMobile.classList.remove("is-open");
			this.mobileNavIsOpen = false;
		} else {
			this.docNavListMobile.classList.add("is-open");
			this.mobileNavIsOpen = true;
		}
	}

	onEventTriggered(e) {
		this.scrollY = window.scrollY;

		for (let i = 0; i < this.doc.chapters.length; i++) {
			const currentChapter = this.doc.chapters[i];
			this.navs.forEach(nav => {
				const currentNavItem = Array.from(
					nav.querySelectorAll(".js-doc-nav-item")
				)[i];
				const currentChapterTopOffset = DocNavigationController.getTopOffset(
					currentChapter
				);
				const currentChapterHeight = this.getHeight(currentChapter);

				if (
					currentChapterTopOffset <= DocNavigationController.getOffset() &&
					currentChapterTopOffset + currentChapterHeight >
						DocNavigationController.getOffset()
				) {
					currentNavItem.classList.add("is-active");
				} else {
					currentNavItem.classList.remove("is-active");
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./Components/DocNavigationController.js